import '../../assets/components/Button/ButtonIcon.css';//#region lib/components/Button/ButtonIcon.module.css
var e = {
	"button-icon": "_button-icon_jaoqy_1",
	"border-radius-8": "_border-radius-8_jaoqy_5",
	"border-radius-12": "_border-radius-12_jaoqy_9"
};
//#endregion
export { e as default };
